export default {
  props: {
    width: {
      type: [Number, String],
      default: 0
    },
    disabled: {
      type: Boolean,
      default: false
    },
    description: {
      type: String,
      default: ''
    },
    customClass: {
      type: String,
      default: ''
    },
    //禁用
    edit: {
      type: Boolean,
      default: true
    },
    //打印只读模式
    printRead: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    styleWidth() {
      return {
        width: this.width ? `${this.width}px` : '100%'
      };
    }

  }
};